import { useState } from 'react';
import { useFormContext, useFormState } from 'react-hook-form';
import DarwinTypography from 'components/darwin-ui/Typography';
import { DarwinTooltip } from 'components/darwin-ui';
import { InfoCircleOutlined } from '@ant-design/icons';
import uiStyles from '../Ui.module.css';

type EditableTextProps = {
  isViewForm: boolean;
  fieldName: string;
  textClassnames: string;
  isTooltip?: boolean;
  defaultText?: string;
};

export const EditableText = ({
  isViewForm,
  fieldName,
  textClassnames,
  isTooltip = false,
  defaultText,
}: EditableTextProps) => {
  const { setValue, watch, control } = useFormContext();
  const { dirtyFields } = useFormState({ control });
  const [isEditing, setIsEditing] = useState(false);

  const getNestedValue = <T extends object>(obj: T, path: string): unknown => {
    return path
      .split('.')
      .reduce((acc: any, part: string) => acc && acc[part], obj);
  };

  const isDirty = !!getNestedValue(dirtyFields, fieldName);

  const currentValue = watch(fieldName);

  const displayText = !isDirty && defaultText ? defaultText : currentValue;

  return (
    <DarwinTypography.Text
      editable={
        !isViewForm
          ? {
              onChange: (newValue: string) => {
                setValue(fieldName, newValue, { shouldDirty: true });
              },
              triggerType: ['text'],
              onStart: () => setIsEditing(true),
              onEnd: () => setIsEditing(false),
            }
          : undefined
      }
      style={{
        marginLeft: isEditing ? '16px' : '0',
        marginTop: isEditing ? '16px' : '0',
        cursor: isViewForm ? 'auto' : 'pointer',
      }}
    >
      {isTooltip ? (
        <DarwinTooltip title={displayText}>
          <span className={uiStyles.tooltip}>
            <InfoCircleOutlined />
          </span>
        </DarwinTooltip>
      ) : (
        <span className={textClassnames}>{displayText}</span>
      )}
    </DarwinTypography.Text>
  );
};
